import React from "react";

import { Logo } from "~/icons";

const Header = () => (
  <header className="xl:px-26 flex w-full px-6 py-6">
    <Logo className="md:h-9" />
  </header>
);

export default Header;
